import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { useNavigate, useParams } from "react-router-dom";
import { getFunctionalAreaById } from "../../actions/JobsAction";
import SuccessMessage from "../common/SuccessMessage";
import ErrorMessage from "../common/ErrorMessage";
import constant from "../../constant";

function AddFunctionalAreas(props) {
  const { id } = useParams();
  const [FUNCTIONAL_AREA, setFUNCTIONAL_AREA] = useState('');
  const [FUNCTIONAL_AREA_DETAILS, setFUNCTIONAL_AREA_DETAILS] = useState("");
  const [FUNCTIONAL_AREA_ID, setFUNCTIONAL_AREA_ID] = useState("");
  const [SORT_NUMBER, setSORT_NUMBER] = useState("");
  const [error, setError] = useState(false)
  const Navigate = useNavigate()
  const params = useParams()

  const onSubmit = (e) => {
    let pn = params.pageno
    e.preventDefault();
    if (FUNCTIONAL_AREA.toString().trim().length === 0 || SORT_NUMBER.toString().trim().length === 0) {
      setError(true)
      return false
    }
    if (id) {
      const model = {
        FUNCTIONAL_AREA: FUNCTIONAL_AREA,
        FUNCTIONAL_AREA_DETAILS: FUNCTIONAL_AREA_DETAILS,
        FUNCTIONAL_AREA_ID: FUNCTIONAL_AREA_ID,
        SORT_NUMBER: SORT_NUMBER,
        type: "UPDATE",
      };
      props.onSubmit(model);
      model.pageno = pn
    } else {
      const model = {
        FUNCTIONAL_AREA: FUNCTIONAL_AREA,
        FUNCTIONAL_AREA_DETAILS: FUNCTIONAL_AREA_DETAILS,
        SORT_NUMBER: SORT_NUMBER,
        type: "ADD",
      };
      props.onSubmit(model);
      model.pageno = pn


    }
  };

  useEffect(() => {
    id && getFunctDetails(id);
    (id ? document.title = constant.title.UpdateFunctionalArea : document.title = constant.title.AddFunctionalArea)
  }, []);


  const getFunctDetails = (id) => {
    getFunctionalAreaById({ FUNCTIONAL_AREA_ID: id })
      .then((res) => {
        if (res.status) {
          setFUNCTIONAL_AREA(res.result[0].FUNCTIONAL_AREA)
          setFUNCTIONAL_AREA_DETAILS(res.result[0].FUNCTIONAL_AREA_DETAILS)
          setFUNCTIONAL_AREA_ID(res.result[0].FUNCTIONAL_AREA_ID)
          setSORT_NUMBER(res.result[0].SORT_NUMBER)
        }
      })
      .catch((err) => {
        alert(err);
      });
  };
  const handleReset = () => {
    id && Navigate(constant.component.listFunctionalArea.url)
    setError(false)
    setFUNCTIONAL_AREA('')
    setFUNCTIONAL_AREA_DETAILS('')
    setSORT_NUMBER("")
  }
  return (
    <React.Fragment>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0" style={{ fontSize: "18px" }}>
                    {id ? " Update Functional Area" : " Add Functional Area"}
                  </h4>

                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <a href="javascript: void(0);">Jobs</a>
                      </li>
                      <li className="breadcrumb-item active">
                        {id ? " Update Functional Area" : " Add Functional Area"}
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title mb-4">
                      Functional Area Information
                    </h4>
                    {
                      props.showMsg && (props.response.status ?
                        <SuccessMessage message={props.response.messageCode} />
                        :
                        <ErrorMessage message={props.response.error} />)
                    }
                    <div id="basic-example">
                      <section>
                        <form method="POST">
                          <div className="row">
                            <div className="col-lg-12">
                              <div className="mb-3">
                                <label for="basicpill-firstname-input">
                                  Functional Area <span className="text-danger"> *</span>
                                </label>
                                <input
                                  type="text"
                                  className={error && FUNCTIONAL_AREA.toString().trim().length <= 0 ? 'form-control is-invalid ' : 'form-control'}
                                  id="basicpill-firstname-input"
                                  placeholder="Enter Functional Area"
                                  value={FUNCTIONAL_AREA}
                                  onChange={e => { setFUNCTIONAL_AREA(e.target.value) }}
                                />
                                {
                                  error && FUNCTIONAL_AREA.toString().trim().length === 0 ? <span className='text-danger ml-1'>This Field is Required</span>
                                    : ""}
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="mb-3">
                                <label for="basicpill-address-input">
                                  Sort Number <span className="text-danger"> *</span>
                                </label>
                                <NumberFormat
                                  allowLeadingZeros={false}
                                  allowNegative={false}
                                  thousandSeparator={false}
                                  maxlength={10}
                                  className={error && SORT_NUMBER.toString().trim().length <= 0 ? 'form-control is-invalid ' : 'form-control'}
                                  id="basicpill-firstname-input"
                                  placeholder="Enter Sort Number"
                                  value={SORT_NUMBER}
                                  onChange={e => { setSORT_NUMBER(e.target.value) }}
                                />
                                {
                                  error && SORT_NUMBER.toString().trim().length === 0 ? <span className='text-danger ml-1'>This Field is Required</span>
                                    : ""}
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="mb-3">
                                <label for="basicpill-address-input">
                                  Functional Area Details
                                </label>
                                <textarea
                                  id="basicpill-address-input"
                                  className="form-control"
                                  rows="2"
                                  placeholder="Enter Functional Area Details"
                                  value={FUNCTIONAL_AREA_DETAILS}
                                  onChange={e => { setFUNCTIONAL_AREA_DETAILS(e.target.value) }}

                                ></textarea>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="mb-3">
                                <button
                                  type="button"
                                  className="btn btn-info waves-effect btn-label waves-light"
                                  onClick={onSubmit}
                                >
                                  <i className="bx bx-check-double label-icon"></i>{" "}
                                  {id ? 'Save Changes' : 'Create Functional Area'}
                                </button>
                                &nbsp;&nbsp;
                                <button
                                  type="button"
                                  onClick={handleReset}
                                  className="btn btn-danger waves-effect btn-label waves-light"
                                >
                                  <i className="bx bx-block label-icon "></i>{" "}
                                  Cancel
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default AddFunctionalAreas;
